import React from "react";
import SellerTracing from "components/Tvendo/Mobile/Tracing/Seller/List.js";
import { LayerProvider } from "contexts/layerContext";

export default function () {
  return (
    <LayerProvider>
      <SellerTracing />
    </LayerProvider>
  );
}
